import axios from 'axios';
import { getNotificationConfig } from '../../../config/apiConfig';
import getLogger from '../../../utils/logger';

export const getNotifications = async (notificationRequest) => {
  // Get auth header config
  const config = await getNotificationConfig();

  const url = `api/notification/inapp/list`;

  return axios
    .post(url, notificationRequest, config)
    .then(async (resp) => {
      let response = {};
      if (resp.data) {
        response = resp.data;
      }
      return response;
    })
    .catch((err) => {
      getLogger().error(err);
      throw err.response;
    });
};

export const getUnreadNotificationCount = async (tenantKey, personId) => {
  // Get auth header config
  const config = await getNotificationConfig();

  const url = `api/notification/inapp/unread/count?tenantKey=${tenantKey}&personId=${personId}`;

  return axios
    .get(url, config)
    .then(async (resp) => {
      let response = {};
      if (resp) {
        response = resp.data;
      }
      return response;
    })
    .catch((err) => {
      getLogger().error(err);
      throw err.response;
    });
};

export const markAllNotificationsAsRead = async (tenantKey, personId) => {
  // Get auth header config
  const config = await getNotificationConfig();

  const url = `api/notification/inapp/markread/all?tenantKey=${tenantKey}&personId=${personId}`;

  return axios
    .post(url, {}, config)
    .then(async (resp) => {
      let response = {};
      if (resp.data) {
        response = resp.data;
      }
      return response;
    })
    .catch((err) => {
      getLogger().error(err);
      throw err.response;
    });
};
export const updateInappNotificationsReadStatus = async (
  tenantKey,
  personId,
  notificationId,
  isRead
) => {
  // Get auth header config
  const config = await getNotificationConfig();

  const url = `api/notification/inapp/updatereadstatus?tenantKey=${tenantKey}&personId=${personId}&notificationId=${notificationId}&IsRead=${isRead}`;

  return axios
    .post(url, {}, config)
    .then(async (resp) => {
      let response = {};
      if (resp.data) {
        response = resp.data;
      }
      return response;
    })
    .catch((err) => {
      getLogger().error(err);
      throw err.response;
    });
};
export const resetUnReadInAppNotificationsCount = async (tenantKey, personId) => {
  // Get auth header config
  const config = await getNotificationConfig();

  const url = `api/notification/inapp/unread/resetcount?tenantKey=${tenantKey}&personId=${personId}`;

  return axios
    .post(url, {}, config)
    .then(async (resp) => {
      let response = {};
      if (resp.data) {
        response = resp.data;
      }
      return response;
    })
    .catch((err) => {
      getLogger().error(err);
      throw err.response;
    });
};
